import type { PageTitleStatus } from './pageTitleStore';

type Translate = (key: string) => string;

/**
 * `{Loading|Error?} - {pageLabel} - {brand}` when status is loading/error;
 * `{pageLabel} - {brand}` when ready.
 */
export function formatDocumentTitle(opts: {
  status: PageTitleStatus;
  pageLabel: string;
  brand: string;
  t: Translate;
}): string {
  const { status, pageLabel, brand, t } = opts;
  const label = pageLabel.trim() || brand;
  if (status === 'loading') {
    return `${t('common.loading')} - ${label} - ${brand}`;
  }
  if (status === 'error') {
    return `${t('common.error')} - ${label} - ${brand}`;
  }
  return `${label} - ${brand}`;
}
